<template>

  <section>

    <div class="container is-fluid">

      <div class="columns is-multiline">

        <div
          class="column is-full"
          v-for="evaluation in $store.state.property.evaluations"
          :key="evaluation.id"
        >

          <!-- SINGLE FAMILY EVALUATION -->
          <section
            class="card moveable-card"
            v-if="evaluation.id.includes('evaluations_')"
          >
            <div class="card-content">
              <nav class="level">
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Equity<br>Capture</p>
                    <p
                      class="subtitle"
                      v-if="showConventional(evaluation)"
                    >{{ evaluation.calculator.conventionalUnrealizedCapitalGain | currency(0) }}</p>
                    <p
                      class="subtitle"
                      v-if="showHard(evaluation)"
                    >{{ evaluation.calculator.hardUnrealizedCapitalGain | currency(0) }}</p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Annual<br>Cash<br>Flow</p>
                    <p
                      class="subtitle"
                      v-if="showConventional(evaluation)"
                    >{{ evaluation.calculator.conventionalAnnualCashFlow | currency(0) }}</p>
                    <p
                      class="subtitle"
                      v-if="showHard(evaluation)"
                    >{{ evaluation.calculator.hardAnnualCashFlow | currency(0) }}</p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Return On<br>Capital<br>Gain</p>
                    <p
                      class="subtitle"
                      v-if="showConventional(evaluation)"
                    >{{ evaluation.calculator.conventionalReturnOnCapitalGainPercent | percent(0) }}</p>
                    <p
                      class="subtitle"
                      v-if="showHard(evaluation)"
                    >{{ evaluation.calculator.hardReturnOnCapitalGainPercent | percent(0) }}</p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Cash On<br>Cash<br>Return</p>
                    <p
                      class="subtitle"
                      v-if="showConventional(evaluation)"
                    >{{ evaluation.calculator.conventionalCashOnCashReturnPercent | percent(1) }}</p>
                    <p
                      class="subtitle"
                      v-if="showHard(evaluation)"
                    >{{ evaluation.calculator.hardCashOnCashReturnPercent | percent(1) }}</p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading"><br>Market<br>Value<br></p>
                    <p class="subtitle">{{ evaluation.calculator.dealTermInputs.estimatedMarketValue | currency(0) }}</p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading"><br>Rent<br>Value<br></p>
                    <p class="subtitle">{{ evaluation.calculator.dealTermInputs.rent | currency(0) }}</p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">#<br>Sale<br>Comps</p>
                    <p class="subtitle">{{ evaluation.saleCompGroup.saleComps.length }}</p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">#<br>Rent<br>Comps</p>
                    <p class="subtitle">{{ evaluation.rentCompGroup.rentComps.length }}</p>
                  </div>
                </div>
              </nav>

              <div>
                <div class="is-size-7">{{ evaluation.lastUpdate | dateMedium }}</div>
                <div class="is-size-7">{{ evaluation.lastUpdate | fromNow }}</div>
                <div class="level">
                  <div class="level-left">
                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="Edit"
                          position="is-top"
                          type="is-info"
                        >
                          <router-link :to="{ name: 'EvaluationDetails', params: { property_id: evaluation.propertyId, evaluation_id: evaluation.id } }">
                            <a
                              class="fas fa-edit"
                              @click="$store.state.evaluation = evaluation"
                            ></a>
                          </router-link>
                        </b-tooltip>
                      </span>
                    </div>
                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="Copy"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-copy"
                            @click="copyEvaluation(evaluation.propertyId, evaluation.id)"
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>
                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="View PDF"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-file-pdf"
                            @click='getEvaluationPdfUrl(evaluation.propertyId, evaluation.id)'
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>
                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="Email"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-envelope"
                            @click="emailEvaluation(evaluation)"
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>
                    <div class="level-item">
                      <span class="icon">
                        <b-tooltip
                          label="Delete"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-trash"
                            @click="deleteEvaluation(evaluation)"
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>
                  </div>
                  <div class="level-item-right has-text-weight-semibold">
                    <table style="margin-left: 5em">
                      <tr>
                        <td
                          class="has-text-grey"
                          v-if="evaluation.notes"
                        >Notes:&nbsp;</td>
                        <td>
                          <div
                            class="has-text-info"
                            v-html="evaluation.notes"
                          />
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </section>
          <!-- SINGLE FAMILY EVALUATION -->

          <!-- MFQA 1 EVALUATION -->
          <section
            class="card moveable-card"
            v-if="evaluation.id.includes('BPOs_')"
          >
            <div class="card-content">
              <div
                class="has-text-weight-semibold"
                style="margin-bottom: 20px"
              >MFQA 1</div>
              <nav class="level">

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading"># Units</p>
                    <p class="subtitle">{{ getUnitCount(evaluation) }}</p>
                  </div>
                </div>

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">{{ evaluation.outputs.actuals.label_E36 }}</p>
                    <p class="subtitle">{{ evaluation.outputs.actuals.brokerPriceOpinionProjection_E78 | currency(0) }}</p>
                  </div>
                </div>

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">{{ evaluation.outputs.brokers.label_F36 }}</p>
                    <p class="subtitle">{{ evaluation.outputs.brokers.brokerPriceOpinionProjection_F78 | currency(0) }}</p>
                  </div>
                </div>

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Proforma</p>
                    <p class="subtitle">{{ evaluation.outputs.proformas.brokerPriceOpinionProjection_G78 | currency(0) }}</p>
                  </div>
                </div>

              </nav>

              <div>
                <div class="is-size-7">{{ evaluation.lastUpdate | dateMedium }}</div>
                <div class="is-size-7">{{ evaluation.lastUpdate | fromNow }}</div>
                <div class="level">
                  <div class="level-left">

                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="Edit"
                          position="is-top"
                          type="is-info"
                        >
                          <router-link :to="{ name: 'BPO', params: { property_id: evaluation.propertyId, bpo_id: evaluation.id } }">
                            <a
                              class="fas fa-edit"
                              @click="$store.state.bpo = evaluation"
                            ></a>
                          </router-link>
                        </b-tooltip>
                      </span>
                    </div>

                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="Copy"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-copy"
                            @click="copyBpo(evaluation.propertyId, evaluation.id)"
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>

                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="View PDF"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-file-pdf"
                            @click='getBpoPdf(evaluation)'
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>

                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="Share link with your Mentor, Agent, Client, or anyone else"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-link"
                            @click="shareEvaluation(evaluation)"
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>

                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="Email"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-envelope"
                            @click="emailBpo(evaluation)"
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>

                    <div class="level-item">
                      <span class="icon">
                        <b-tooltip
                          label="Delete"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-trash"
                            @click="deleteBpo(evaluation)"
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>

                    <div class="level-item">
                      <b-tooltip
                        label="Create a new MFQA 2 from this MFQA 1. The MFQA 2 is a more in-depth evaluation that includes the 9 expense categories from NAA. Do it after your LOI is accepted. Keep updating it as you progress through due diligence."
                        position="is-top"
                        multilined
                        type="is-info"
                      >
                        <button
                          class="button is-link is-small"
                          @click="createBpo2(evaluation)"
                        >
                          <span class="icon">
                            <i class="fas fa-arrow-circle-right"></i>
                          </span>
                          <span>MFQA 2</span>
                        </button>
                      </b-tooltip>
                    </div>

                  </div>
                  <div class="level-item-right has-text-weight-semibold">
                    <table style="margin-left: 5em">
                      <tr>
                        <td
                          class="has-text-grey"
                          v-if="evaluation.outputs.notes_I45"
                        >Notes:&nbsp;</td>
                        <td>
                          <div
                            class="has-text-info"
                            v-html="evaluation.outputs.notes_I45"
                          />
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </section>
          <!-- MFQA 1 EVALUATION -->

          <!-- MFQA 2 EVALUATION -->
          <section
            class="card moveable-card"
            v-if="evaluation.id.includes('BPO2s_')"
          >
            <div class="card-content">
              <div
                class="has-text-weight-semibold"
                style="margin-bottom: 20px"
              >MFQA 2</div>
              <nav class="level">

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">{{ evaluation.outputs.actuals.label_J38 }}</p>
                    <p class="subtitle">{{ evaluation.outputs.actuals.brokerPriceOpinionProjection_J78 | currency(0) }}</p>
                  </div>
                </div>

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">{{ evaluation.outputs.brokers.label_K38 }}</p>
                    <p class="subtitle">{{ evaluation.outputs.brokers.brokerPriceOpinionProjection_K78 | currency(0) }}</p>
                  </div>
                </div>

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">{{ evaluation.outputs.proformasYear1.label_L38 }}</p>
                    <p class="subtitle">{{ evaluation.outputs.proformasYear1.brokerPriceOpinionProjection_L78 | currency(0) }}</p>
                  </div>
                </div>

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">{{ evaluation.outputs.proformasYear2.label_M38 }}</p>
                    <p class="subtitle">{{ evaluation.outputs.proformasYear2.brokerPriceOpinionProjection_M78 | currency(0) }}</p>
                  </div>
                </div>

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">{{ evaluation.outputs.proformasYear3.label_N38 }}</p>
                    <p class="subtitle">{{ evaluation.outputs.proformasYear3.brokerPriceOpinionProjection_N78 | currency(0) }}</p>
                  </div>
                </div>

                <div
                  class="level-item has-text-centered"
                  v-if="evaluation.inputs.showProformasYear4And5"
                >
                  <div>
                    <p class="heading">{{ evaluation.outputs.proformasYear4.label_O38 }}</p>
                    <p class="subtitle">{{ evaluation.outputs.proformasYear4.brokerPriceOpinionProjection_O78 | currency(0) }}</p>
                  </div>
                </div>

                <div
                  class="level-item has-text-centered"
                  v-if="evaluation.inputs.showProformasYear4And5"
                >
                  <div>
                    <p class="heading">{{ evaluation.outputs.proformasYear5.label_P38 }}</p>
                    <p class="subtitle">{{ evaluation.outputs.proformasYear5.brokerPriceOpinionProjection_P78 | currency(0) }}</p>
                  </div>
                </div>

              </nav>

              <div>
                <div class="is-size-7">{{ evaluation.lastUpdate | dateMedium }}</div>
                <div class="is-size-7">{{ evaluation.lastUpdate | fromNow }}</div>
                <div class="level">
                  <div class="level-left">

                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="Edit"
                          position="is-top"
                          type="is-info"
                        >
                          <router-link :to="{ name: 'BPO2', params: { property_id: evaluation.propertyId, bpo2_id: evaluation.id } }">
                            <a
                              class="fas fa-edit"
                              @click="$store.state.bpo2 = evaluation"
                            ></a>
                          </router-link>
                        </b-tooltip>
                      </span>
                    </div>

                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="Copy"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-copy"
                            @click="copyBpo2(evaluation.propertyId, evaluation.id)"
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>

                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="View PDF"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-file-pdf"
                            @click='getBpo2Pdf(evaluation)'
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>

                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="Share link with your Mentor, Agent, Client, or anyone else"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-link"
                            @click="shareEvaluation(evaluation)"
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>

                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="Email"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-envelope"
                            @click="emailBpo2(evaluation)"
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>

                    <div class="level-item">
                      <span class="icon">
                        <b-tooltip
                          label="Delete"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-trash"
                            @click="deleteBpo2(evaluation)"
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>

                    <div class="level-item">
                      <b-tooltip
                        label="Create a new Long Form evaluation from this MFQA 2. The Long-Form is the most in-depth evaluation and is done when Due Diligence is complete."
                        position="is-top"
                        multilined
                        type="is-info"
                      >
                        <button
                          class="button is-link is-small"
                          @click="createLongForm(evaluation)"
                        >
                          <span class="icon">
                            <i class="fas fa-arrow-circle-right"></i>
                          </span>
                          <span>Long Form</span>
                        </button>
                      </b-tooltip>
                    </div>

                  </div>
                  <div class="level-item-right has-text-weight-semibold">
                    <table style="margin-left: 5em">
                      <tr>
                        <td
                          class="has-text-grey"
                          v-if="evaluation.outputs.notes_H80"
                        >Notes:&nbsp;</td>
                        <td>
                          <div
                            class="has-text-info"
                            v-html="evaluation.outputs.notes_H80"
                          />
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </section>
          <!-- MFQA 2 EVALUATION -->

          <!-- LONG FORM EVALUATION -->
          <section
            class="card moveable-card"
            v-if="evaluation.id.includes('LongForms_')"
          >
            <div class="card-content">
              <div
                class="has-text-weight-semibold"
                style="margin-bottom: 20px"
              >Long Form</div>
              <nav class="level">

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Year 1</p>
                    <p class="subtitle">{{ evaluation.netCash.annual.value | currency(0) }}</p>
                  </div>
                </div>

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Year 2</p>
                    <p class="subtitle">{{ evaluation.netCash.year2.value | currency(0) }}</p>
                  </div>
                </div>

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Year 3</p>
                    <p class="subtitle">{{ evaluation.netCash.year3.value | currency(0) }}</p>
                  </div>
                </div>

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Year 4</p>
                    <p class="subtitle">{{ evaluation.netCash.year4.value | currency(0) }}</p>
                  </div>
                </div>

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Year 5</p>
                    <p class="subtitle">{{ evaluation.netCash.year5.value | currency(0) }}</p>
                  </div>
                </div>

                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Year 6</p>
                    <p class="subtitle">{{ evaluation.netCash.year6.value | currency(0) }}</p>
                  </div>
                </div>

              </nav>

              <div>
                <div class="is-size-7">{{ evaluation.lastUpdate | dateMedium }}</div>
                <div class="is-size-7">{{ evaluation.lastUpdate | fromNow }}</div>
                <div class="level">
                  <div class="level-left">

                    <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="Edit"
                          position="is-top"
                          type="is-info"
                        >
                          <router-link :to="{ name: 'LongForm', params: { property_id: evaluation.propertyId, longform_id: evaluation.id } }">
                            <a
                              class="fas fa-edit"
                              @click="$store.state.longform = evaluation"
                            ></a>
                          </router-link>
                        </b-tooltip>
                      </span>
                    </div>

                    <!-- <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="Copy"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-copy"
                            @click="copyBpo2(evaluation.propertyId, evaluation.id)"
                          ></a>
                        </b-tooltip>
                      </span>
                    </div> -->

                    <!-- <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="View PDF"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-file-pdf"
                            @click='getBpo2Pdf(evaluation)'
                          ></a>
                        </b-tooltip>
                      </span>
                    </div> -->

                    <!-- <div class="level-item">
                      <span class="link">
                        <b-tooltip
                          label="Email"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-envelope"
                            @click="emailBpo2(evaluation)"
                          ></a>
                        </b-tooltip>
                      </span>
                    </div> -->

                    <div class="level-item">
                      <span class="icon">
                        <b-tooltip
                          label="Delete"
                          position="is-top"
                          type="is-info"
                        >
                          <a
                            class="fas fa-trash"
                            @click="deleteLongform(evaluation)"
                          ></a>
                        </b-tooltip>
                      </span>
                    </div>

                  </div>

                  <!-- <div class="level-item-right has-text-weight-semibold">
                    <table style="margin-left: 5em">
                      <tr>
                        <td
                          class="has-text-grey"
                          v-if="evaluation.outputs.notes_H80"
                        >Notes:&nbsp;</td>
                        <td>
                          <div
                            class="has-text-info"
                            v-html="evaluation.outputs.notes_H80"
                          />
                        </td>
                      </tr>
                    </table>
                  </div> -->

                </div>
              </div>
            </div>

          </section>
          <!-- LONG FORM EVALUATION -->

        </div>

      </div>

    </div>

    <b-modal
      :active.sync="$store.state.isEmailEvaluationActive"
      has-modal-card
      :canCancel="[]"
    >
      <EmailEvaluation />
    </b-modal>

    <b-modal
      :active.sync="$store.state.isEmailBpoActive"
      has-modal-card
      :canCancel="[]"
    >
      <EmailBPO />
    </b-modal>

    <b-modal
      :active.sync="$store.state.isEmailBpo2Active"
      has-modal-card
      :canCancel="[]"
    >
      <EmailBPO2 />
    </b-modal>

    <b-modal
      :active.sync="$store.state.isShareEvaluationActive"
      has-modal-card
      :canCancel="[]"
    >
      <ShareEvaluation />
    </b-modal>

  </section>

</template>

<script>
import store from "@/store";
import { routes } from "@/routes";
import LiberatorService from "@/services/LiberatorService.js";
import EmailEvaluation from "@/components/properties/EmailEvaluation.vue";
import EmailBPO from "@/components/properties/evaluations/multifamily/EmailBPO.vue";
import EmailBPO2 from "@/components/properties/evaluations/multifamily/EmailBPO2.vue";
import ShareEvaluation from "@/components/properties/evaluations/multifamily/ShareEvaluation.vue";

export default {
  components: {
    routes,
    LiberatorService,
    EmailEvaluation,
    EmailBPO,
    EmailBPO2,
    ShareEvaluation
  },
  methods: {
    getUnitCount(bpo) {
      if (bpo.outputs.rents.length == 0) return 0;
      return bpo.outputs.rents.reduce((a, b) => ({
        unitCount: a.unitCount + b.unitCount
      })).unitCount;
    },

    showConventional(evaluation) {
      var ret = false;
      if (evaluation.calculator.conventionalInputs.show) ret = true;
      if (!this.showHard(evaluation)) ret = true;
      return ret;
    },

    showHard(evaluation) {
      var ret = false;
      if (
        !evaluation.calculator.conventionalInputs.show &&
        evaluation.calculator.hardMoneyInputs.show
      )
        ret = true;
      return ret;
    },

    emailEvaluation(evaluation) {
      console.log("emailEvaluation()", evaluation);
      this.$store.commit("UPDATE_EVALUATION", evaluation);
      this.$store.state.isEmailEvaluationActive = true;
    },

    emailBpo(evaluation) {
      console.log("emailBpo()", evaluation);
      this.$store.commit("UPDATE_EVALUATION", evaluation);
      this.$store.state.isEmailBpoActive = true;
    },

    emailBpo2(evaluation) {
      console.log("emailBpo2()", evaluation);
      this.$store.commit("UPDATE_EVALUATION", evaluation);
      this.$store.state.isEmailBpo2Active = true;
    },

    shareEvaluation(evaluation) {
      console.log("shareEvaluation()", evaluation);
      this.$store.commit("UPDATE_EVALUATION", evaluation);
      this.$store.state.isShareEvaluationActive = true;
    },

    async createBpo2(evaluation) {
      console.log("createBpo2()", evaluation);
      var propertyId = evaluation.propertyId;
      var bpoId = evaluation.id;
      await this.$store.dispatch("createBpo2", { propertyId, bpoId });
      console.log(
        "TCL: this.$store.state.bpo2.propertyId",
        this.$store.state.bpo2.propertyId
      );
      console.log("TCL: this.$store.state.bpo2.id", this.$store.state.bpo2.id);
      await this.$router.push({
        name: "BPO2",
        params: {
          property_id: this.$store.state.bpo2.propertyId,
          bpo2_id: this.$store.state.bpo2.id
        }
      });
    },

    async createLongForm(evaluation) {
      console.log("createLongForm()", evaluation);
      var propertyId = evaluation.propertyId;
      var bpo2Id = evaluation.id;
      await this.$store.dispatch("createLongFormFromBpo2", {
        propertyId,
        bpo2Id
      });
      console.log(
        "TCL: this.$store.state.longform.propertyId",
        this.$store.state.longform.propertyId
      );
      console.log(
        "TCL: this.$store.state.bpo2.id",
        this.$store.state.longform.id
      );
      await this.$router.push({
        name: "LongForm",
        params: {
          property_id: this.$store.state.longform.propertyId,
          longform_id: this.$store.state.longform.id
        }
      });
    },

    deleteEvaluation(evaluation) {
      console.log("TCL: deleteEvaluation -> evaluation", evaluation);
      this.$buefy.dialog.confirm({
        title: "Deleting evaluation",
        message: `Delete this evaluation? <b>It cannot be undone!</b>`,
        confirmText: "Delete Evaluation",
        cancelText: "Cancel",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          store.dispatch("deletePropertyEvaluation", evaluation);
          this.$buefy.toast.open({
            message: "Evaluation deleted",
            type: "is-success",
            duration: 3000
          });
        }
      });
    },

    deleteBpo(bpo) {
      this.$buefy.dialog.confirm({
        title: "Deleting MFQA 1 evaluation",
        message: `Delete this MFQA 1 evaluation? <b>It cannot be undone!</b>`,
        confirmText: "Delete MFQA 1 Evaluation",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          store.dispatch("deleteBpo", bpo);
          this.$toast.open({
            message: "MFQA 1 Evaluation deleted",
            type: "is-success",
            duration: 3000
          });
        }
      });
    },

    deleteBpo2(bpo2) {
      this.$buefy.dialog.confirm({
        title: "Deleting MFQA 2 evaluation",
        message: `Delete this MFQA 2 evaluation? <b>It cannot be undone!</b>`,
        confirmText: "Delete MFQA 2 Evaluation",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          store.dispatch("deleteBpo2", bpo2);
          this.$toast.open({
            message: "MFQA 2 Evaluation deleted",
            type: "is-success",
            duration: 3000
          });
        }
      });
    },

    deleteLongform(longform) {
      this.$buefy.dialog.confirm({
        title: "Deleting Long Form evaluation",
        message: `Delete this Long Form evaluation? <b>It cannot be undone!</b>`,
        confirmText: "Delete Long Form Evaluation",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          store.dispatch("deleteLongform", longform);
          this.$toast.open({
            message: "Long Form Evaluation deleted",
            type: "is-success",
            duration: 3000
          });
        }
      });
    },

    copyEvaluation(propertyId, evaluationId) {
      store.dispatch("copyEvaluation", { propertyId, evaluationId });
    },

    copyBpo(propertyId, bpoId) {
      store.dispatch("copyBpo", { propertyId, bpoId });
    },

    copyBpo2(propertyId, bpo2Id) {
      store.dispatch("copyBpo2", { propertyId, bpo2Id });
    },

    async getBpoPdf(bpo) {
      console.log("getBpoPdf", bpo.propertyId, bpo.guid);

      await this.$store.dispatch("getBpoPdf", bpo).then(async response => {
        var url = response.data;

        this.$buefy.dialog.alert({
          title: "View PDF",
          message: `<div class="level"><div class="level-left"><a href=${url} target="_blank"><i class="far fa-file-pdf fa-4x"></i></a></div><div class="level-right"><a href=${url} target="_blank">CLICK HERE TO VIEW PDF</a></div></div>`,
          confirmText: "Done"
        });

        return response.data;
      });
    },

    async getBpo2Pdf(bpo2) {
      console.log("getBpo2Pdf", bpo2.propertyId, bpo2.guid);

      await this.$store.dispatch("getBpo2Pdf", bpo2).then(async response => {
        var url = response.data;

        this.$buefy.dialog.alert({
          title: "View PDF",
          message: `<div class="level"><div class="level-left"><a href=${url} target="_blank"><i class="far fa-file-pdf fa-4x"></i></a></div><div class="level-right"><a href=${url} target="_blank">CLICK HERE TO VIEW PDF</a></div></div>`,
          confirmText: "Done"
        });

        return response.data;
      });
    },

    async getEvaluationPdfUrl(propertyId, evaluationId) {
      var sessionKey = this.$store.getters.session.sessionKey;
      await this.$store
        .dispatch("getEvaluationPdfUrl", {
          propertyId,
          evaluationId,
          sessionKey
        })
        .then(async response => {
          var url = response.data;

          this.$buefy.dialog.alert({
            title: "View PDF",
            message: `<div class="level"><div class="level-left"><a href=${url} target="_blank"><i class="far fa-file-pdf fa-4x"></i></a></div><div class="level-right"><a href=${url} target="_blank">CLICK HERE TO VIEW PDF</a></div></div>`,
            confirmText: "Done"
          });

          return response.data;
        });
    }
  },

  props: ["property_id", "evaluation_id", "session_key", "evaluation"],

  data() {
    return {
      session: store.state.session
    };
  }
};
</script>

<style>
</style>
